import { Link } from "@inertiajs/react";
import { CompanyLogo } from "@/components/CompanyLogo.tsx";
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/components/ui/card.tsx";
import { bizminer_app_account_root_path } from "@/routes";
import type { BizminerAccount } from "@/types/serializers";
import { LISTING_STATUS_LABELS } from "./listingStatus.ts";

export function AccountCard({ account }: { account: BizminerAccount }) {
  return (
    <Link href={bizminer_app_account_root_path({ account_id: account.id })}>
      <Card className="cursor-pointer hover:shadow-lg transition-all hover:border-primary">
        <CardContent>
          <div className="flex items-start gap-3">
            <CompanyLogo
              logoUrl={account.logo_url}
              name={account.name}
              className="size-12 rounded-lg flex-shrink-0"
            />
            <div className="flex-1 min-w-0">
              <CardTitle className="text-sm font-semibold leading-snug truncate">
                {account.name}
              </CardTitle>
              {account.gics_classification?.name && (
                <CardDescription className="text-xs font-normal leading-snug truncate">
                  {account.gics_classification.name}
                </CardDescription>
              )}
              {account.listing_status && LISTING_STATUS_LABELS[account.listing_status] && (
                <CardDescription className="text-xs font-normal leading-snug truncate">
                  {LISTING_STATUS_LABELS[account.listing_status]}
                </CardDescription>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
